import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import successIcon from "../assets/alert-success.svg"
import { useNavigate } from 'react-router-dom';

export default function ThankyouModal({ show, onHide }) {

  const navigate = useNavigate();

  return (
    <>
      <Modal show={show}>
        <Modal.Header style={{ margin: "0 auto", borderBottom: "0 none" }}>
          <div>
            <img style={{
              height: 70,
              width: 70
            }} src={successIcon} alt="icon" />
          </div>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          <h5>Thank you for volunteering. We will get back to you shortly.</h5> <br />
          <h5> Do you already have a student? If yes, you will be redirected to the student registration form after submission.</h5>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "0 none", margin: "0 auto" }}>
          <Button variant="primary" style={{ minWidth: 220, borderRadius: 15 }} onClick={() => {
            window.open("https://student.letsteachenglish.org/")
          }}>
            Yes, I have a student
          </Button>
          <Button variant="warning" style={{ minWidth: 220, borderRadius: 15 }} onClick={() =>
            // window.location.reload() 
            navigate('/end')
          }>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}